import './BrokerTable.css';
import { ReactComponent as HumanIcon } from '../../assets/icons/BrokerRating/humans.svg';

export interface BrokerItem {
  title: string;
  key: string;
  totalAnalysist: number;
  accessor: string;
}
export type BrokerTableProps = {
  data: BrokerItem[];
};

const BrokerTable = ({ data }: BrokerTableProps) => {
  return (
    <div className="brokerTable-container">
      {data.map((item, index) => (
        <>
        <div className="brokerTable-row" key={item.key}>
          <div className={`brokerTable-title brokerTable-title-${item.key}`}>{item.title}</div>
          <div className="brokerTable-total">{item.totalAnalysist}</div>
          <div className={`brokerTable-icon-container`}>
            {Array(item.totalAnalysist)
              .fill(true)
              .map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <HumanIcon className={`brokerTable-icon ${item.key}`} key={index} />
              ))}
          </div>          
        </div>  
               {/* {index < data.length - 1 && <hr className="brokerTable-divider"/>  }      */}
               <div className="brokerTable-line"/>

        </>
        
      ))}
      <hr className="brokerTable-divider" />
    </div>
  );
};
export default BrokerTable;
